import { GradesIcon, SectionIcon, GradesIconActive } from "./components/svgIcons";

export const menuItems = [
    {
        label: 'Admissions',
        icon: 'pi pi-building',
        items: [
            // { label: 'Image', image: 'dssd', separator: true },
            { label: 'Admissions' },
            { label: 'Dashboard', separator: true },
            { label: 'Dashboard', icon: 'pi pi-home', to: '/admissiondashboard' },
            { label: 'Dashboard', icon: 'pi pi-id-card', to: '/', separator: true },
            // { label: 'Admissions' },
            { label: 'Enquiry', icon: 'pi pi-id-card', to: '/enquiry' },
            { label: 'Application', icon: 'pi pi-check-square', to: '/admission-application' },
            { label: 'Exam/Test', icon: 'pi pi-bookmark', to: '/admission-exam' },
            { label: 'Registration', icon: 'pi pi-exclamation-circle', to: '/admission-registration' },
            { label: 'Enrollment', icon: 'pi pi-mobile', to: '/admission-enrollment' },
            {
                label: 'Reports',
                icon: 'pi pi-table',
                to: '',
                items: [
                    { label: 'Multi Stage Conversion Graphs', to: '/multistageconversiongraphs' },
                    { label: 'Individual Applicant Timeline', to: '/individualApplicantTimelineReport' },
                    { label: 'Weekly/Monthly Funnel Report', to: '/funnelreport' },
                    // { label: '# Registration Report', to: '' },
                    // { label: '# Enrollment Report', to: '' },
                    // { label: '# Admission Fee Report', to: '' },
                    // { label: '# Demographic Report', to: '' },
                    // { label: '# Grade Wise Report', to: '' }
                ]
            }
        ]
    },
    { separator: true },
    {
        label: 'Fee Decision',
        icon: 'pi pi-chart-pie', // Or a suitable icon from the docs
        items: [
            { label: 'Fee Decision Engine' },
            { label: 'Dashboard', icon: 'pi pi-home', to: '/feeDecisionDashboard' }, // Placeholder for dashboard
            
            // MODULE 1: Fee Audit & Bulk Data Ingestion
            { 
                label: 'Fee Audit & Data Ingestion', 
                icon: 'pi pi-upload', 
                items: [
                    { label: 'Bulk Upload', to: '/finance-bulk-upload' },
                    { label: 'Data Integrity Report', to: '/financeNew/DataIntegrityReport' }
                ]
            },

            // MODULE 2: Fee Ledger & Discount Context
            {
                label: 'Fee Ledger & Discounts',
                icon: 'pi pi-book',
                items: [
                    { label: 'Fee Ledger', to: '/financeNew/FeeLedger' },
                    { label: 'Discount Disparity', to: '/financeNew/DiscountDisparity' }
                ]
            },

            // MODULE 3: Parent / Payer Profile & Cash-Flow Context
            {
                label: 'Parent Profiles & Cash-Flow',
                icon: 'pi pi-users',
                items: [
                    { label: 'Payer Profiles', to: '/financeNew/PayerProfiles' },
                    { label: 'Primary Contacts', to: '/financeNew/PrimaryContacts' }
                ]
            },

            // MODULE 4: Risk Scoring
            {
                label: 'Risk Scoring',
                icon: 'pi pi-exclamation-triangle',
                items: [
                    { label: 'Risk Overview', to: '/financeNew/RiskOverview' },
                    { label: 'Risk Configuration', to: '/financeNew/RiskConfiguration' }
                ]
            },

            // MODULE 5: Payment Predictions
            {
                label: 'Payment Predictions',
                icon: 'pi pi-chart-line',
                items: [
                    { label: 'Collection Forecast', to: '/financeNew/CollectionForecast' },
                    { label: 'Default Probability', to: '/financeNew/DefaultProbability' }
                ]
            },

            // MODULE 6: Prescriptive Actions (NBA)
            {
                label: 'Prescriptive Actions',
                icon: 'pi pi-check-square',
                items: [
                    { label: 'Action Queue', to: '/financeNew/ActionQueue' },
                    { label: 'Action Approvals', to: '/financeNew/ApprovalRequests' }
                ]
            },
           
            // MODULE 7: Communication Triggers Removed

             
             // MODULE 8: Mobile Execution & Call Logs
            {
                label: 'Mobile & Call Logs',
                icon: 'pi pi-phone',
                items: [
                    { label: 'Call Tasks', to: '/financeNew/CallTasks' },
                    { label: 'Call Outcomes Log', to: '/financeNew/CallOutcomesLog' }
                ]
            },

            // MODULE 9 & 11: Learning & Audit (Combined governance)
            {
                label: 'Learning & Governance',
                icon: 'pi pi-cog',
                items: [
                    { label: 'Promises & Breaches', to: '/financeNew/PromisesBreaches' },
                    { label: 'Risk Adjustment History', to: '/financeNew/RiskAdjustmentHistory' },
                    { label: 'Action Queue Management', to: '/financeNew/ActionQueueManagement' },
                    { label: 'Risk Score Approvals', to: '/financeNew/RiskScoreApprovals' },
                    { label: 'Action Effectiveness', to: '/financeNew/ActionEffectiveness' },
                    { label: 'Channel Learning', to: '/financeNew/ChannelLearning' },
                    { label: 'Audit Trail', to: '/financeNew/AuditTrail' }
                ]
            }

        ]
    },
    { separator: true },
    {
        label: 'Students',
        icon: 'fa fa-graduation-cap',
        items: [
            // { label: 'Image', image: 'ddd' },
            { label: 'Students' },
            { label: 'Dashboard', separator: true },
            { label: 'Dashboard', icon: 'pi pi-home', to: '/studentsdashboard' },
            { label: 'Dashboard', separator: true },


            { label: 'Student Information', icon: 'pi pi-id-card', to: '/studentInfo' },

            { label: 'Attendance', icon: 'pi pi-check-square', to: '/attendance' },
            { label: 'Student Transfer', icon: 'pi pi-exclamation-circle', to: '/studentTransfer' },
            { label: 'Student Status Change', icon: 'pi pi-exclamation-circle', to: '/studentStatusChange' },
            { label: 'Student Promotion', icon: SectionIcon, to: '/studentPromotion' },
            {label: "Student Profile", icon: 'pi pi-user', to: '/studentProfile'},
            {
                label: "Reports",
                to: '',
                items: [
                    { label: '# Student Information Report', to: '/studentinforeport' },
                    { label: '# Student Status Change Report', to: '/studentstatuschangereport' },
                    { label: '# Student Attendance Report', to: '/studentsattendancereport' },
                    // { label: '# Attendance Summary Report', to: '/attendancesummaryreport' },

                ]

            }
        ]
    },
    { separator: true },
    {
        label: 'Finance',
        icon: 'fa fa-money',
        items: [
            // { label: 'Image', image: 'dds' },
            { label: 'Finance' },
            { label: 'Dashboard', separator: true },
            { label: 'Dashboard', icon: 'pi pi-home', to: 'financeDashboard' },
            { label: 'Dashboard', separator: true },

            { label: 'Collect Fee/Fee Challan', icon: 'pi pi-building', to: '/collectFee' },
            { label: 'Ad Hoc Charges', icon: 'pi pi-plus-circle', to: '/adHocCharges' },
            // { label: 'Assign Fee', icon: 'pi pi-info-circle', to: '/assignFee' },
            { label: 'Fee Unassign', icon: 'pi pi-bookmark', to: '/UnAssignFee' },
            { label: 'Fee Concession', icon: 'pi pi-info-circle', to: '/feeConcession' },
            { label: 'Fee Refund', icon: 'pi pi-info-circle', to: '/feeRefund' },
            { label: 'Cheque/DD Status', icon: 'pi pi-circle', to: '/chequeOrDDstatus' },
            {
                label: 'Reports',
                icon: 'pi pi-table',
                to: '',
                items: [
                    { label: '# Fee Collection', to: '/feecollectionreport' },
                    { label: '# Fee Due', to: '/feeduereport' },
                    { label: '# Concession', to: '/feeconcessionreport' },
                    { label: '# Fee Unassign', to: '/unassignreports' },
                    /*   { label: '# Fine', to: '' },*/
                    { label: '# Refund', to: '/refundreport' },
                    /* { label: '# Age wise Fee Due ', to: '/agewisefeeduereport' }, */
                ]
            },
        ]
    },
    { separator: true },
    {
        label: 'Academics',
        icon: 'fa fa-thin fa-book',
        items: [
            { label: 'Academics' },
            { label: 'Dashboard', separator: true },
            { label: 'Dashboard', icon: 'pi pi-home', to: '/academicsDashboard' },
            { label: 'Dashboard', separator: true },
            // { label: 'Academics' },
            { label: 'Academic Calendar', icon: 'pi pi-calendar pi-calendar-clock', to: '/AcademicCalendar' },
            // { label: 'Teacher Dairy Template', icon: 'pi pi-check-square', to: '/TeacherDiaryTemplate' },
            // { label: 'Teacher Dairy', icon: 'pi pi-bookmark', to: '/TeacherDiary' },
            { label: 'Digital Library', icon: 'pi pi-exclamation-circle', to: '/DigitalLibrary' },
            { label: 'Subject Assignment', icon: 'pi pi-book', to: '/SubjectAssignment' },
            { label: 'Grading Scheme', icon: 'pi pi-chart-bar', to: '/GradingScheme' },
            { label: 'Subjective Examination', icon: 'pi pi-file-edit', to: '/SubjectiveExamination' },
            {
                label: 'Examination',
                icon: 'pi pi-mobile',
                items: [
                    { label: '# Create Test', to: '/CreateTest' },
                    { label: '# Question Bank', to: '/QuestionBank' },
                    // { label: '# Create Test Type', to: '/CreateTestType' },
                    { label: '# Create Template ', to: '/CreateTemplate' },
                    { label: '# Tests & Exams', to: '/TestsandExams' }
                ]
            },
            {
                label: 'Reports',
                icon: 'pi pi-table',
                to: '',
                items: [
                    {
                        label: '# Objective Reports',
                        icon: 'pi pi-chart-line',
                        items: [
                            { label: '# Branch Analysis', to: '/branchAnalysisReport' },
                            { label: '# Error Analysis', to: '/errorAnalysisReport' },
                            { label: '# Student Error', to: '/studentErrorReport' },
                            { label: '# Cumulative Analysis', to: '/cumulativeAnalysis' },
                            { label: '# Branch Wise Highest Marks Average', to: '/branchWiseMarksReport' },
                            { label: '# Errors List Report (Student Wise)', to: '/studentWiseErrorsReport' },
                            { label: '# Section Wise Exam Analysis', to: '/sectionWiseExamAnalysisReport' },
                            { label: '# Students Subject Wise Marks', to: '/studentSubjectWiseMarksReport' },
                            { label: '# Objective Exams Branch Wise Rank Analysis', to: '/objectiveExamsReport' },
                        ]
                    },
                    {
                        label: '# Subjective Reports',
                        icon: 'pi pi-file-edit',
                        items: [
                            { label: '# Total Report', to: '/subjectiveExamTotalReport' },
                            { label: '# Marks Entry Report', to: '/marksEntryStatus' },
                        ]
                    }
                ]
            },
            // {
            //     label: 'Progress Report',
            //     icon: 'pi pi-table',
            //     items: [
            //         { label: '# Grading System ', to: '/GradingSystem ' },
            //         { label: '# Performance Analytics ', to: '/PerformanceAnalytics' },
            //         { label: '# Grade Book Template', to: '/GradeBookTemplate' },
            //         { label: '# Grade Book', to: '/GradeBook' }
            //     ]
            // },
            // { label: 'Approval Hierarchy', icon: 'pi pi-list', to: '/ApprovalHierarchy' },
            // { label: 'Reports', icon: 'pi pi-share-alt', to: '/Reports' }
        ]
    },
    { separator: true },
    {
        label: 'Timetable',
        icon: 'fa fa-clock-o',
        items: [
            { label: 'Timetable' },
            // { label: 'Dashboard', separator: true },
            // { label: 'Dashboard', icon: 'pi pi-home', to: '/' },
            { label: 'Dashboard', separator: true },
            // { label: 'Timetable' },
            { label: 'My Timetable', icon: 'pi pi-id-card', to: '/myTimeTable' },
            { label: 'Request Substitution', icon: 'pi pi-check-square', to: '/requestSubstitution' },
            // { label: 'Lag Report', to: '/lagReport', icon: 'pi pi-bookmark' },
            // { label: 'TimeTable Reports', icon: 'pi pi-exclamation-circle', to: 'timeTableReports' }
        ]
    },
    { separator: true },
    {
        label: 'Transport',
        icon: 'pi pi-car',
        items: [
            { label: 'Transport' },
            { label: 'Dashboard', separator: true },
            { label: 'Dashboard', icon: 'pi pi-home', to: '/transportdashboard' },
            { label: 'Dashboard', separator: true },
            // { label: 'Transport' },
            { label: 'Assign Transport', icon: 'pi pi-id-card', to: '/assigntransport' },
            { label: 'Route  Management', icon: 'pi pi-check-square', to: '/routemanagement' },
            { label: 'Transport Fee Receivables', to: '/transportfeereceivables', icon: 'pi pi-bookmark' },
            {
                label: 'Reports',
                icon: 'pi pi-mobile',
                items: [
                    { label: '# Transport Fee Reports', to: '/transportfeereport' },
                    { label: '# Route Utilization Report', to: '/routeUtilizationreport' },
                    // { label: '# Fuel Details', to: '/fueldetails' },
                    // { label: '# Maintenance report ', to: '/maintenancereport' }
                ]
            }
        ]
    },

    { separator: true },
    {
        label: 'Communicate',
        icon: 'pi pi-fw pi-comment',
        items: [
            { label: 'Communicate' },
            { label: 'Dashboard', separator: true },
            { label: 'Dashboard', icon: 'pi pi-home', to: '/communicate-dashboard' },
            { label: 'Dashboard', separator: true },
            // Actual menu items
            { label: 'Notification', icon: 'pi pi-bell', to: '/communicate-notification' },
            { label: 'Notification Workflows', icon: 'pi pi-sliders-h', to: '/notification-workflows' },
            { label: 'Fee Decision Notification Workflow', icon: 'pi pi-chart-line', to: '/fee-decision-notification-workflows' },
            // { label: 'Communication Approvals', icon: 'pi pi-check-square', to: '/communicate-approvals' },
            { label: 'Templates Management', icon: 'pi pi-file', to: '/templates-management' }
        ]
    },
    { separator: true },
    {
        label: 'Approvals',
        icon: 'fa fa-star-o',
        items: [
            { label: 'Approvals' },
            // { label: 'Dashboard', separator: true },
            // { label: 'Dashboard', icon: 'pi pi-home', to: '/' },
            { label: 'Dashboard', separator: true },
            // { label: 'Approvals' },
            { label: 'Fee Concession', icon: 'pi pi-id-card', to: '/approvals-fee-concession' },
            { label: 'Fee Refund', icon: 'pi pi-check-square', to: '/approvals-fee-refund' },
            { label: 'Fee Unassign', icon: 'pi pi-bookmark', to: '/approvals-Fee-unassign' },
            { label: 'Student Transfer', icon: 'pi pi-exclamation-circle', to: '/transferPendingStudents' },
            { label: 'Student Status Change', icon: 'pi pi-check-square', to: '/approvals-studentstatuschange' },
            { label: 'Assign Transport', icon: 'pi pi-check-square', to: '/approvals-assigntransport' },
            { label: 'Transport Route', icon: 'pi pi-check-square', to: '/approvals-transportroute' },
            { label: 'Substitution Request', icon: 'pi pi-check-square', to: '/approvals-substitutionrequest' },
            { label: 'Receipt Modification', icon: 'pi pi-check-square', to: '/approvals-receipt-modification' },
            { label: 'Student Promotions', icon: 'pi pi-check-square', to: '/approvals-studentpromotions' }
        ]
    },
    { separator: true },
    {
        label: 'Settings',
        icon: 'pi pi-fw pi-cog',
        items: [
            { label: 'Settings' },
            { label: 'Dashboard', separator: true },
            // { label: 'Dashboard', icon: 'pi pi-home', to: '/' },
            // { label: 'Dashboard', separator: true },
            // { label: 'Settings' },
            { label: 'School Setup', icon: 'pi pi-id-card', to: '/schoolSetup' },
            { label: 'Academics', icon: 'pi pi-check-square', to: '/acadamics' },
            { label: 'Fee Setup', icon: 'pi pi-bookmark', to: '/feesetup' },
            { label: 'Finance General Settings', icon: 'fa fa-money', to: '/financeGeneralSettings' },
            { label: 'Finance', icon: 'fa fa-money', to: '/finance' },

            { label: 'Admission', icon: 'pi pi-mobile', to: '/admissionManagement' },
            { label: 'Staff Allocation', icon: 'fa fa-money', to: '/staff' },
            { label: 'Transport', icon: 'pi pi-car', to: '/transportManagement' },
            { label: 'Roles & Users', icon: 'pi pi-list', to: '/rolesAndUsers' },
            { label: 'Promotions', icon: SectionIcon, to: '/promotions' },
            { label: 'Timetable', icon: 'pi pi-table', to: '/settimetable' },
            { label: 'Transactions', icon: 'pi pi-table', to: '/transactions-list' },

            {
                label: 'Approval Hierarchy',
                icon: 'pi pi-table',
                to: '',
                items: [
                    { label: '# Fee Concession', to: '/approval-hierarchy-fee-concession' },
                    { label: '# Fee Refund', to: '/approval-hierarchy-fee-refund' },
                    { label: '# Fee Unassign', to: '/approval-hierarchy-fee-unassign' },
                    { label: '# Student Status Change', to: '/approval-hierarchy-status-change' },
                    { label: '# Student Transfer', to: '/approval-hierarchy-student-transfer' },
                    { label: '# Assign Transport', to: '/approval-hierarchy-assign-transport' },
                    { label: '# Transport Route', to: '/approval-hierarchy-transport-route' },
                    { label: '# Substitution Request', to: '/approval-hierarchy-substitution-request' },
                    { label: '# Receipt Modification', to: '/approval-hierarchy-receipt-modification' },
                    { label: '# Student Promotions', to: '/approval-hierarchy-student-promotions' },
                ]
            },
            { separator: true }
        ]
    },
    { separator: true },
    {
        label: 'Org Setup',
        icon: 'pi pi-fw pi-share-alt',
        to: '/organization-setup'
    }
];
